<div class="map-wrapper">
    <app-loader [display]="loading" [background]="true"></app-loader>
    <div class="map-border">
        <div id="map"></div>
    </div>
</div>